import promise from 'promise'
import { AxiosInstance } from 'axios'

export default (instance: AxiosInstance): void => {
	instance.interceptors.request.use(
		function (config) {
			const accessToken = localStorage.getItem('access_token')
			if (accessToken) {
				if (config.method !== 'OPTIONS') {
					config.headers && (config.headers['x-access-token'] = accessToken)
				}
			}
			return config
		},
		function (error) {
			return promise.reject(error)
		}
	)
}
